module.exports = __webpack_public_path__ + "img/type-flat.8abf73e1.svg";